export const FilterGroupTitles: Record<string, string> = {
  dateFilter: 'Time',
  vehicleFilter: 'Vehicles',
  demographicFilter: 'Demographics',
  locationFilter: 'Areas',
  personalFilter: 'Personal',
  stopDetailsFilter: 'Stop Details',
  citationTypes: 'Offence Desc',
};

export const FilterTitles: Record<string, string> = {
  // Date
  fromDate: 'From date',
  toDate: 'To date',
  daysOfWeek: 'Days of week',
  months: 'Months',
  dayNight: 'Day / night',
  // Vehicles
  colors: 'Colors',
  makes: 'Makes',
  types: 'Types',
  models: 'Models',
  releaseDateFrom: 'Release date from',
  releaseDateTo: 'Release date to',
  // Demographics
  races: 'Races',
  gender: 'Gender',
  ageGroup: 'Age group',
  // Location
  zipCodes: 'Zip codes',
  cities: 'Cities',
  // Personal
  officerId: 'Officer id',
  officerName: 'Officer name',
  // Reasons for stop
  reasonsForStop: 'Reasons for stop',
  reasonsForSearch: 'Reasons for search',
  contrabandOrEvidence: 'Contraband or evidence',
  resultsOfStop: 'Results of stop',
};

export const YEAR_FORMATS = {
  parse: {
    dateInput: '',
  },
  display: {
    dateInput: 'YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};
